var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.section.cta
    ? _c(
        "div",
        {
          staticClass: "cta text-nav",
          on: {
            click: function ($event) {
              return _vm.$emit("click")
            },
          },
        },
        [
          _c("strong", {
            staticClass: "label",
            domProps: { innerHTML: _vm._s(_vm.section.cta) },
          }),
          _vm._v(" "),
          _c("hero-link-icon"),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }